// Section 17: priority group 'My household'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function myHousehold(_config: Config) {
  return definePriorityGroup({
    id: 'my-household',
    label: 'My household',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter((p) => ctx.state.myHousehold.includes(p.id))
        .map((p) => p.id),
  });
}
